import { useState } from "react";

import { useViewportInfoContext } from "@/src/contexts";

import type { ILogoTile } from "../common/LogoTile";
import LogoTile from "../common/LogoTile";

import * as css from "./DiscountHeader.module.css";

export interface IDiscountHeader {
    caption?: string;
    title: string;
    logoTile: ILogoTile;
    isDiscountSaved?: boolean;
    isBrandObserved?: boolean;
    isFlyer: boolean;
    pageDescription?: string;
    discountType: string;
    itemDescription: string;
    brandName: string;
    canonicalUrl: string;
    validityText?: string;
}

export const DiscountHeader = (props: IDiscountHeader) => {
    const [jsonLdString] = useState(
        JSON.stringify({
            "@@context": "http://schema.org/",
            "@@type": "Product",
            name: props.title,
            description: props.itemDescription,
            image: props.logoTile.logo.src,
            logo: props.logoTile.logo.src,
            category: props.discountType,
            sameAs: props.canonicalUrl,
            brand: {
                "@@type": "Thing",
                name: props.brandName,
            },
        }),
    );

    const { isDesktop, isLaptop } = useViewportInfoContext();
    const showValidityText = props.validityText && (isDesktop || isLaptop);

    const renderDescription = () => {
        const discountCaption = props.caption && <h1 className={css.discountCaption}>{props.caption}</h1>;

        if (props.isFlyer) {
            return (
                <div className={css.headerDescription}>
                    <div className={css.descriptionBox}>
                        {discountCaption}
                        <span className={css.flyerTitle}>
                            <span className={css.title}>
                                {props.title}
                                {props.pageDescription && (
                                    <span className={css.pageDescription}>{props.pageDescription}</span>
                                )}
                                {showValidityText && (
                                    <span
                                        className={css.validityText}
                                        dangerouslySetInnerHTML={{
                                            __html: props.validityText,
                                        }}
                                    />
                                )}
                            </span>
                        </span>
                    </div>
                </div>
            );
        }

        return (
            <div className={css.headerDescription}>
                <div className={css.descriptionBox}>
                    {discountCaption}
                    <span className={css.discountTitle}>{props.title}</span>
                </div>
            </div>
        );
    };

    return (
        <div className={css.discountHeaderComponent}>
            {props.logoTile && (
                <div className={css.itemButtonWrapper}>
                    <LogoTile {...props.logoTile} type="brands" shouldComponentUpdate />
                </div>
            )}
            {renderDescription()}
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdString }} />
        </div>
    );
};
